<template>
  <div class="table">
    <div class="container">
      <!--=========查询模块================-->
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="餐厅国际编号" prop="storeNo">
                <el-input v-model="queryCondition.storeNo"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="餐厅名称" prop="storeName">
                <el-input v-model="queryCondition.storeName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="餐厅城市" prop="storeCity">
                <el-input v-model="queryCondition.storeCity"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <!--=========查询模块END================-->
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <!--=========数据列表================-->
      <el-table sortable max-height="435" :data="storeList" ref="dcDataTable" border highlight-current-row class="table" :row-key="getRowKeys" @selection-change="handleSelectionChange">
        <el-table-column v-if="multipleSelectionFlag" prop="tmStoreId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmStoreId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="storeNo" label="餐厅国际编号"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="storeName" label="餐厅名称"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="storeCity" label="餐厅城市"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="isDirect" label="是否直营">
          <template slot-scope="scope">{{scope.row.isDirect|ic("TT_FEEDBACK","IS_DIRECT_SALE")}}</template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
  </div>
</template>
<script>
import { storeService } from "../../../api/base-data/store";
import commonFunction from "../../../utils/dataTableUtils"
export default {
  name: 'store-sel-page',
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },

  },
  data() {
    return {
      totalCount: 0,
      storeList: [],
      labelPosition: 'right',
      queryCondition: { pageSize: 15, pageNum: 1, storeNo: "", storeName: "", storeCity: "" },
      statusList: [],
      multipleSelection: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      storeService.getStoreData(this.queryCondition).then((res) => {
        this.storeList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows);
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    cancelSeleted: function () {
      this.radioVal = null;
      this.selectRows = null;
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
